import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConsentBanner, installErrorReporting, ToastProvider } from '@cfg/ui';
import '@cfg/ui/styles.css';
import './app.css';
import { analytics, PRIVACY_URL } from './analytics';
import { App } from './App';
import { initialLocale } from './i18n';

installErrorReporting({
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  app: 'kitchen',
});

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 2, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App initialLocale={initialLocale()} />
        <ConsentBanner analytics={analytics} locale={initialLocale()} privacyUrl={PRIVACY_URL} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
